import * as firebase from "firebase/app"
import { getFirestore } from 'firebase/firestore';


const firebaseConfig = {
        apiKey: "AIzaSyCj1mussFT1zd-aq_Ks4jpudAIeuMGBUZE",
        authDomain: "carrefourdesmetiers-79167.firebaseapp.com",
        projectId: "carrefourdesmetiers-79167",
        storageBucket: "carrefourdesmetiers-79167.appspot.com",
        messagingSenderId: "754550433443",
        appId: "1:754550433443:web:92a7744522ba69165b0116"
      };

const app = firebase.initializeApp(firebaseConfig);
const db = getFirestore(app);

export {db}